/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataSourcesListResponse } from '../../models/data-sources-list-response';

export interface DataControllerDataSourcesList$Params {
}

export function dataControllerDataSourcesList(http: HttpClient, rootUrl: string, params?: DataControllerDataSourcesList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourcesListResponse>> {
  const rb = new RequestBuilder(rootUrl, dataControllerDataSourcesList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataSourcesListResponse>;
    })
  );
}

dataControllerDataSourcesList.PATH = '/planning-projects/v1-develop/data/data-sources';
